/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S2_HoursInputs */

const tr_iletisim_s2_hours = /** @type {(inputs: Iletisim_S2_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hafta içi 09:00 ile 18:00 (UTC+3) arası, genellikle 1 iş günü içinde yanıt.`)
};

const en_iletisim_s2_hours = /** @type {(inputs: Iletisim_S2_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekdays between 09:00 and 18:00 (UTC+3), usually answered within 1 business day.`)
};

const de_iletisim_s2_hours = /** @type {(inputs: Iletisim_S2_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montags bis freitags von 09:00 bis 18:00 Uhr (UTC+3), Antwort in der Regel innerhalb eines Arbeitstags.`)
};

const ru_iletisim_s2_hours = /** @type {(inputs: Iletisim_S2_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В будни с 09:00 до 18:00 (UTC+3), ответ, как правило, в течение одного рабочего дня.`)
};

/**
* | output |
* | --- |
* | "Weekdays between 09:00 and 18:00 (UTC+3), usually answered within 1 business day." |
*
* @param {Iletisim_S2_HoursInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s2_hours = /** @type {((inputs?: Iletisim_S2_HoursInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S2_HoursInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s2_hours(inputs)
	if (locale === "de") return de_iletisim_s2_hours(inputs)
	if (locale === "ru") return ru_iletisim_s2_hours(inputs)
	return tr_iletisim_s2_hours(inputs)
});